import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import InnerHTML from '@Components/InnerHTML';
import { Button } from '@els/els-react--button';

import './SynonymsList.scss';

function SynonymsList({ synonyms, limit = 4, minHeight = 0, separator = ', ', className, label }) {
  const selfRef = useRef();
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    setExpanded(false);
  }, [synonyms]);

  const toggleExpanded = () => {
    const toggled = !expanded;
    const el = selfRef.current;

    if (el) {
      el.style.maxHeight = toggled ? `${Math.max(el.clientHeight, minHeight)}px` : '';
    }
    setExpanded(toggled);
  };

  const withShowMore = synonyms.length > limit;

  return (
    <div ref={selfRef} className={cn('synonyms-list', { 'synonyms-list--expanded': expanded }, className)}>
      {label}
      <InnerHTML html={(withShowMore && !expanded ? synonyms.slice(0, limit) : synonyms).join(separator)} />
      {withShowMore &&
        (expanded ? (
          <Button
            data-e2e="synonyms-show-less-button"
            type="link"
            className="synonyms-list__show-more-button e2e-show-less"
            onClick={toggleExpanded}>
            {' - show less'}
          </Button>
        ) : (
          <Button
            data-e2e="synonyms-show-more-button"
            type="link"
            className="synonyms-list__show-more-button e2e-show-more"
            onClick={toggleExpanded}>
            {` +${synonyms.length - limit} more`}
          </Button>
        ))}
    </div>
  );
}

SynonymsList.propTypes = {
  synonyms: PropTypes.array.isRequired,
  limit: PropTypes.number,
  minHeight: PropTypes.number,
  separator: PropTypes.node,
  className: PropTypes.string,
  label: PropTypes.node,
};

export default SynonymsList;
